import { Link } from 'react-router-dom';
import CookieBanner from './CookieBanner';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#1a2e2e] to-[#0f1f1f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <h3 className="text-2xl font-serif font-bold">VACIADOS MARIUS</h3>
              <span className="w-2 h-2 bg-teal-500 rounded-full"></span>
            </div>
            <p className="text-xl font-serif text-gray-300 mb-6 leading-relaxed">
              Vaciado profesional<br />en Barcelona
            </p>
            <div className="flex items-center space-x-2">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 px-4 py-2 bg-transparent border border-gray-500 rounded-full text-sm text-white placeholder-gray-400 focus:outline-none focus:border-teal-500"
              />
              <button className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-full hover:bg-teal-700 transition-colors cursor-pointer">
                <i className="ri-notification-3-line text-white"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/servicios#vaciado-completo" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Vaciado completo
                </Link>
              </li>
              <li>
                <Link to="/servicios#recogida-muebles" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Recogida de muebles
                </Link>
              </li>
              <li>
                <Link to="/servicios#herencias" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Vaciados por herencia
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Empresa</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/empresa" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Quiénes somos
                </Link>
              </li>
              <li>
                <Link to="/empresa#como-trabajamos" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Cómo trabajamos
                </Link>
              </li>
              <li>
                <Link to="/#cobertura" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Zona de cobertura
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contacto</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Tel: 936 94 00 41</li>
              <li>WhatsApp: 633 759 649</li>
              <li>vaciadosmarius@gmail.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-sm text-gray-400">
            © 2025 Vaciados Marius. Todos los derechos reservados.
          </p>

          <div className="flex items-center space-x-4">
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-gray-500 rounded-lg hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-gray-500 rounded-lg hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-fill text-lg"></i>
            </a>
            <a
              href="https://share.google/FizsQeezE7RkuyEkt"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-gray-500 rounded-lg hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer"
            >
              <i className="ri-google-fill text-lg"></i>
            </a>
            <a
              href="https://wa.me/34633759649"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-gray-500 rounded-lg hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-lg"></i>
            </a>
          </div>

          <div className="flex items-center space-x-4 text-sm">
            <Link to="/privacidad" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
              Política de Privacidad
            </Link>
            <Link to="/aviso-legal" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
              Aviso Legal
            </Link>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link 
            to="/servicios"
            className="text-xs text-gray-500 hover:text-teal-400 transition-colors cursor-pointer"
          >
            Powered by VM
          </Link>
        </div>
      </div>
      
      <CookieBanner />
    </footer>
  );
}
